import type { ILearningModuleRepository } from '@/core/domain/learning/module/ILearningModuleRepository.ts'
import type { LearningModule } from '@/core/domain/learning/module/LearningModule.ts'
import type { ILearningModuleUrlOptions } from '@/core/domain/learning/module/ILearningModuleUrlOptions.ts'

export class FetchLearningModuleUseCase {
  private learningModuleRepository: ILearningModuleRepository

  constructor(learningModuleRepository: ILearningModuleRepository) {
    this.learningModuleRepository = learningModuleRepository
  }

  async execute(
    courseId: number,
    moduleId: number,
    options?: ILearningModuleUrlOptions
  ): Promise<LearningModule> {
    return await this.learningModuleRepository.fetchLearningModule(courseId, moduleId, options)
  }
}
